import React from "react";
import AddressCard from "./addressCard";

const UserDetail = ({ Invocedata }) => {
  return (
    <div className="card rounded-3 shadow-sm mb-3">
      <div className="card-body">
        <h5 className="fw-bold mb-3 border-bottom pb-2">
          Customer Info
        </h5>

        {[
          { label: "Order Date:", value: Invocedata?.orderDate },
          { label: "Name:", value: Invocedata?.user?.name },
          { label: "Email:", value: Invocedata?.user?.email },
          { label: "Contact No:", value: Invocedata?.user?.mobile_number },
        ].map((item, idx) => (
          <div key={idx} className="row mb-2">
            <div className="col-3 fw-semibold">{item.label}</div>
            <div className="col-9">{item.value || "-"}</div>
          </div>
        ))}

        <hr className="my-3 border-2 border-dark" />

        <div className="row mt-3">
          <div className="col-md-6">
            <AddressCard
              title="Shipping Address"
              address={Invocedata?.shippingAddress}
            />
          </div>
          <div className="col-md-6">
            <AddressCard
              title="Billing Address"
              address={Invocedata?.billingAddress}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default UserDetail;
